import mainurl from "../config/mainurl.mjs"

const otpapifunc = async (CC,Uid,Otp) => {
  var otpresp={}
  const otpurl=`${mainurl}/verifyOTP`
  await fetch(otpurl, {
    method: "POST",
    headers: { "Content-Type":"application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa"},
    body: JSON.stringify({cc: CC, uid: Uid, otp: Otp}),
  }).then((resp) => resp.json()).then(result=>{
    // console.log(result);
   (Object.assign(otpresp,(result)))
  }).catch(error=>{
    // console.log(error);
  })
  return otpresp
};
export default otpapifunc;